import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardPage from './DashboardPage';
import SalesTrafficPage from './SalesTrafficPage';
import BuyBoxPage from './BuyBoxPage';

const RepricerDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/sales-traffic" element={<SalesTrafficPage />} />
        <Route path="/buybox" element={<BuyBoxPage />} />
      </Routes>
    </div>
  );
};

export default RepricerDashboard;
